<template>
  <div class="w-100 mx-auto">
    <VueApexCharts
      type="donut"
      :options="donutChart.options"
      :series="donutChart.series"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      donutChart: {
        series: [
          706, 8, 4, 759, 6, 4, 3, 148, 2, 136, 3, 86, 128, 74, 2, 335, 107, 16,
          15, 197,
        ],
        options: {
          labels: [
            "Kebenaran Merancang",
            "Kebenaran Merancang (Menara atau Struktur Komunikasi)",
            "Kebenaran Merancang bagi Industrial Green Lane (IGL)",
            "Pelan Bangunan",
            "Pelan Bangunan (Menara atau Struktur Komunikasi)",
            "Pelan Bangunan bagi Industrial Green Lane (IGL)",
            "Pelan Bangunan bagi Self Regulation (SR)",
            "Pelan Jalan Dan Perparitan",
            "Pelan Jalan Dan Perparitan bagi Industrial Green Lane (IGL)",
            "Pelan Kerja Tanah",
            "Pelan Kerja Tanah bagi Industrial Green Lane (IGL)",
            "Pelan Lampu Jalan",
            "Pelan Landskap",
            "Penamaan Taman/Jalan/Bangunan (TJB)",
            "Permit Pembinaan Kecil bagi EVCB",
            "Permit (Kerja Ubah Suai Kecil)",
            "Permit Sementara",
            "Permit Sementara (Menara atau Struktur Komunikasi)",
            "Permit Sementara Bangunan Rumah Pekerja Tapak Bina",
            "Lain-lain",
          ],
          chart: {
            width: 380,
            type: "donut",
          },
          plotOptions: {
            pie: {
              startAngle: -90,
              endAngle: 270,
            },
          },
          dataLabels: {
            enabled: true,
          },
          fill: {
            type: "gradient",
          },
          legend: {
            formatter: function (val, opts) {
              return val + " - " + opts.w.globals.series[opts.seriesIndex];
            },
          },
          // title: {
          //   text: "Gradient Donut with custom Start-angle",
          // },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  components: {
    VueApexCharts,
  },
};
</script>
